export const LEGACY_COOKIE_NAME = 'solfin-cookie-consent';
export const COOKIE_EXPIRY_DAYS = 365;

export const COOKIE_CATEGORIES = [
  {
    id: 'necessary',
    name: 'Necessary Cookies',
    description:
      'Essential cookies required for basic website functionality, security, and user authentication.',
    icon: '🔒',
    required: true,
    examples: ['Session management', 'Security tokens', 'Load balancing']
  },
  {
    id: 'analytics',
    name: 'Analytics Cookies',
    description:
      'Help us understand visitor behavior through anonymous data collection and reporting.',
    icon: '📊',
    required: false,
    examples: ['Google Analytics', 'Page views', 'User interactions']
  },
  {
    id: 'marketing',
    name: 'Marketing Cookies',
    description:
      'Enable personalized advertising and remarketing based on your interests.',
    icon: '🎯',
    required: false,
    examples: ['Google Ads', 'Facebook Pixel', 'Conversion tracking']
  },
  {
    id: 'preferences',
    name: 'Preference Cookies',
    description:
      'Remember your choices and settings to provide a personalized experience.',
    icon: '⚙️',
    required: false,
    examples: ['Language settings', 'Theme preferences', 'Form data']
  }
];

export const PRIVACY_LINKS = {
  cookiePolicy: '/policies/cookie',
  privacyPolicy: '/policies/privacy-policy'
};

export const ANIMATION_DURATION = 300;
export const MODAL_Z_INDEX = 10001;
export const BANNER_Z_INDEX = 10000;
